import { Reveal, MaskLines, SectionLabel } from "./Motion";

const BLOCKS = [
  {
    t: "Une convention écrite, dès le départ",
    d: "Conformément à la loi, une convention d'honoraires est signée avant toute intervention. Elle précise les prestations, le mode de calcul des honoraires et les frais prévisibles. Vous savez à quoi vous vous engagez.",
  },
  {
    t: "Un honoraire de base",
    d: "Il rémunère le travail accompli sur votre dossier : forfait par étape ou temps passé, selon ce qui est convenu ensemble au regard de la nature et de la complexité de l'affaire. La majorité des victimes représentées par le cabinet ne font jamais l'avance des honoraires, qui seront facturés uniquement lorsque des fonds sont perçus de la part de la compagnie d'assurance ou du Fonds de garantie (selon les cas).",
  },
  {
    t: "Un honoraire de résultat complémentaire",
    d: "Il peut s'y ajouter un honoraire complémentaire, exprimé en pourcentage des sommes effectivement obtenues. Son taux est fixé à l'avance dans la convention ; il n'est dû qu'en cas de résultat et n'est jamais la seule rémunération de l'avocat. En France, il est en effet prohibé pour un Avocat de ne facturer qu'un seul honoraire de résultat, lequel ne peut être qu'un complément à celui de base.",
  },
];

export const Honoraires = () => (
  <section id="honoraires" data-testid="honoraires-section" className="relative overflow-hidden bg-[#1F2F29] py-28 text-[#FAF8F5] sm:py-36">
    <div className="grain absolute inset-0" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal><SectionLabel index="04" light>Honoraires</SectionLabel></Reveal>
          <h2 className="font-serif-d mt-8 text-4xl font-light leading-[1.08] sm:text-5xl lg:text-6xl">
            <MaskLines lines={["La transparence,", <><em className="italic text-[#D9C193]">avant tout</em>.</>]} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-[#D6DDD9]">
              Parler d'argent au moment où l'on traverse une épreuve n'est jamais simple. C'est pourquoi les conditions
              d'intervention sont expliquées clairement dès le premier rendez-vous, sans surprise.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          {BLOCKS.map((b, i) => (
            <Reveal key={b.t} delay={i * 0.08}>
              <div data-testid={`honoraires-block-${i}`} className="border-t border-[#E5DEC9]/20 py-8">
                <div className="flex gap-6">
                  <span className="font-serif-d w-6 shrink-0 pt-1 text-sm italic text-[#D9C193]">{["I", "II", "III"][i]}</span>
                  <div>
                    <h3 className="font-serif-d text-2xl sm:text-3xl">{b.t}</h3>
                    <p className="mt-4 text-[0.98rem] leading-relaxed text-[#D6DDD9]">{b.d}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal>
            <p className="border-t border-[#E5DEC9]/20 pt-8 text-sm leading-relaxed text-[#C9D2CD]">
              Votre contrat d'assurance (protection juridique) peut prendre en charge tout ou partie des frais d'avocat ; le cabinet
              vérifie avec vous vos garanties. Selon vos ressources, l'aide juridictionnelle peut également être sollicitée.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
